import { CommentStatus } from "@/features/comments/comment-status";
import { useApiQuery } from "@/lib/api/hooks";

/** The comment id a run looked at (`eventRef` = "comment:<id>"), or null for DMs. */
export function runCommentId(eventRef: string): string | null {
  const [kind, id] = eventRef.split(":");
  return kind === "comment" && id ? id : null;
}

/**
 * The status of the comment a run touched (deleted / hidden / ⚡ rule / replied, and by whom), through the shared
 * <CommentStatus/>. Runs don't carry the comment DTO yet, so this reads the comment once per row (cached 5 min).
 * Follow-up: have the runs API include the comment status fields, then pass them straight in.
 */
export function RunCommentStatus({ eventRef, variant = "compact", className }: { eventRef: string; variant?: "compact" | "full"; className?: string }) {
  const id = runCommentId(eventRef);
  const q = useApiQuery("commentDetail", { params: { commentId: id ?? "" } }, { enabled: !!id, staleTime: 5 * 60_000, retry: false });
  if (!id || !q.data) return null;
  return <CommentStatus comment={q.data.comment} variant={variant} className={className} />;
}
